import React, { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import Navbar from './navbar';
import Footer from './sections/footer';

export default function UnsubscribePage() {
  const [searchParams] = useSearchParams();
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle, loading, success, error
  const [message, setMessage] = useState('');

  useEffect(() => {
    const emailParam = searchParams.get('email');
    if (emailParam) {
      setEmail(emailParam);
    }
  }, [searchParams]);

  const handleUnsubscribe = async (e) => {
    e.preventDefault();
    if (!email) return;

    setStatus('loading');
    try {
      const API_URL = process.env.REACT_APP_API_URL || "https://api.adolphefrantzley.best/api";
      const res = await fetch(`${API_URL}/newsletter/unsubscribe`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });

      if (!res.ok) throw new Error('Failed to unsubscribe');
      
      setStatus('success');
      setMessage("You have been successfully removed from our mailing list. We're sorry to see you go!");
    } catch (error) {
      setStatus('error');
      setMessage("Something went wrong. Please check your email and try again.");
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <div className="flex items-center justify-center py-32 px-5">
        <div className="max-w-md w-full bg-[#131315] rounded-[2.5rem] p-10 shadow-2xl text-center relative overflow-hidden">
          {/* Decorative blur */}
          <div className="absolute -top-20 -right-20 w-40 h-40 bg-[#3aa1ff]/10 rounded-full blur-[60px]"></div>

          {status === 'success' ? (
            <div className="relative z-10 animate-fade-in">
              <div className="w-20 h-20 bg-[#3aa1ff]/10 rounded-full flex items-center justify-center mx-auto mb-6">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-10 w-10 text-[#3aa1ff]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <h2 className="text-2xl font-Poppins font-bold text-white mb-4">Unsubscribed</h2>
              <p className="text-gray-400 font-Inter mb-8 leading-relaxed">
                {message}
              </p>
              <Link 
                to="/"
                className="inline-block bg-white text-[#131315] font-Poppins font-bold px-8 py-4 rounded-2xl hover:bg-gray-200 transition-all"
              >
                Back to Home
              </Link>
            </div>
          ) : (
            <div className="relative z-10">
              <h2 className="text-3xl font-Poppins font-bold text-white mb-4">Unsubscribe</h2>
              <p className="text-gray-400 font-Inter mb-8">
                Confirm your email address below to stop receiving our newsletter.
              </p>
              
              <form onSubmit={handleUnsubscribe} className="flex flex-col gap-4">
                <input 
                  type="email" 
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="your@email.com"
                  required
                  className="w-full bg-[#1a1a1c] border border-gray-800 text-white px-6 py-4 rounded-2xl font-Inter focus:outline-none focus:border-[#3aa1ff] transition-all"
                />
                <button 
                  type="submit"
                  disabled={status === 'loading'}
                  className="w-full bg-[#3aa1ff] text-white font-Poppins font-bold py-4 rounded-2xl hover:bg-[#288ce6] transition-all disabled:opacity-50"
                >
                  {status === 'loading' ? 'Processing...' : 'Confirm Unsubscribe'}
                </button>
              </form>
              
              {status === 'error' && (
                <p className="mt-4 text-red-400 text-sm font-medium animate-shake">
                  {message}
                </p>
              )}

              <div className="mt-8 pt-8 border-top border-gray-800">
                <Link to="/" className="text-gray-500 hover:text-white transition-colors text-sm">
                  Changed your mind? Go back
                </Link>
              </div>
            </div>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
}
